import type { Group } from './Group';

export class Section {
  public id: string = '';
  public label: string = '';
  public groups: Group[] = [];
}
